import { DocumentoModel, EnderecoModel, PessoaModel, TelefoneModel } from './pessoa.model';

function apenasDigitos(value: string | null | undefined): string {
  return (value ?? '').replace(/\D/g, '');
}

function higienizarDocumento(doc: DocumentoModel): DocumentoModel | null {
  if (doc.is_deleted) {
    return { ...doc };
  }

  const codigoPrincipal = apenasDigitos(doc.codigo_principal);
  if (!codigoPrincipal && !doc.id) {
    return null;
  }

  return {
    ...doc,
    codigo_principal: codigoPrincipal,
  };
}

function higienizarTelefone(tel: TelefoneModel): TelefoneModel | null {
  if (tel.is_deleted) {
    return {
      ...tel,
      ddd: apenasDigitos(tel.ddd),
      numero: apenasDigitos(tel.numero),
    };
  }

  const ddd = apenasDigitos(tel.ddd);
  const numero = apenasDigitos(tel.numero);
  if (!ddd && !numero && !tel.id) {
    return null;
  }

  return {
    ...tel,
    ddd,
    numero,
  };
}

function higienizarEndereco(end: EnderecoModel): EnderecoModel | null {
  if (end.is_deleted) {
    return {
      ...end,
      cep: apenasDigitos(end.cep),
    };
  }

  const cep = apenasDigitos(end.cep);
  if (!end.logradouro && !cep && !end.id) {
    return null;
  }

  return {
    ...end,
    cep,
  };
}

/** Remove máscaras e linhas vazias antes do POST/PUT de pessoa. */
export function higienizarPayloadPessoa(model: PessoaModel): PessoaModel {
  const documentos = (model.documentos ?? [])
    .map((doc) => higienizarDocumento(doc))
    .filter((doc): doc is DocumentoModel => doc != null);

  const telefones = (model.telefones ?? [])
    .map((tel) => higienizarTelefone(tel))
    .filter((tel): tel is TelefoneModel => tel != null);

  const enderecos = (model.enderecos ?? [])
    .map((end) => higienizarEndereco(end))
    .filter((end): end is EnderecoModel => end != null);

  return {
    ...model,
    cpf: apenasDigitos(model.cpf),
    documentos,
    telefones,
    enderecos,
  };
}
